import { post } from './commonFetch';
import { TravelerOptOutRequest } from '../types/travelerOptOut';

interface TravelerRegisterResponse {
  success: boolean;
  profileExist: boolean;
}

export const travelerOptOut = (
  travelerOptOutInfo: TravelerOptOutRequest,
): Promise<TravelerRegisterResponse> =>
  post('/traveler/optOut', travelerOptOutInfo);